import { ELEVATION_1 } from './constants';
import { ContainerStyleTokens } from './types';

export const DEFAULT_NESTED_ACTION_CONTAINER_STYLE: ContainerStyleTokens = {
    '--ContainerBgColor': '#fff',
    '--ContainerBorderRadius': '16px',
    '--ContainerElevationFocusWithin': ELEVATION_1,
    '--ContainerElevationHover': ELEVATION_1,
};
